var map = {
	"./button.svg": "1a03",
	"./copy.svg": "b3bd",
	"./delete.svg": "922e",
	"./devCode.svg": "a4ad",
	"./edit.svg": "a917",
	"./flash.svg": "668c",
	"./goodAppraise.svg": "1d59",
	"./image.svg": "2391",
	"./invisible.svg": "bad1",
	"./livebroadcast.svg": "8f47",
	"./logo.svg": "178d",
	"./minus.svg": "8135",
	"./minus1.svg": "02f8",
	"./multiimg.svg": "554e",
	"./music.svg": "0951",
	"./office.svg": "69eb",
	"./paste.svg": "b4a8",
	"./pdf.svg": "c9ed",
	"./plus1.svg": "7eac",
	"./priceTag.svg": "1585",
	"./qrCode.svg": "2099",
	"./template.svg": "067a",
	"./time.svg": "654a",
	"./view.svg": "dd27",
	"./visible.svg": "a381",
	"./wechat.svg": "a704"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4cb9";